import appFeatures from 'effective-features!';
import rootTemplate from 'text!portal/views/root.html';
import AuthenticationService from 'plugin?auth-type!gw-portals-auth-js/AuthenticationService';
import 'angularRouter';
import 'gw-portals-tracking-angular';
import 'gw-portals-tracking-angular/adapters/module';
import GetXcenterEntryPoint from 'gw-portals-platform-js/entryPoint/GetXcenterEntryPoint';
import AuthConfigUtil from 'gw-portals-auth-js/utils/AuthConfigUtil';
import {getConfigValue, getAndExtendConfigValue} from 'gw-portals-config';
import _ from 'lodash';

// Flag to separate /app (Dev) and distribution builds
const IS_DISTRIBUTION_BUILD = /* DISTRIBUTION_BUILD_START*/true/* DISTRIBUTION_BUILD_END*/;

let homeState = 'claimlist';
let homeUrl = '/claims/list';
if (angular.isArray(appFeatures.role) && appFeatures.role.indexOf('vendor') !== -1) {
    if (appFeatures['service-requests']) {
        homeState = 'serviceRequestsList';
        homeUrl = '/service-requests/list';
    } else {
        homeState = 'activitieslist';
        homeUrl = '/activities/list';
    }
}

const eventAdapterModules = ['gw-portals-tracking-angular.adapters'];

/**
 * Module used to define application level configuration parameters that should be
 * passed to capability modules
 */

export default angular.module('portal.config', ['ui.router', 'gw-portals-tracking-angular', ...eventAdapterModules])
    .config(['adapters.googleAnalyticsProvider', 'CredentialsProvider', (googleAnalyticsProvider, credentialsProvider) => {
        googleAnalyticsProvider.configure(credentialsProvider.getCredentials('googleAnalytics'));
    }])
    .config(['adapters.segmentIOProvider', 'CredentialsProvider', (segmentIOProvider, credentialsProvider) => {
        segmentIOProvider.configure(credentialsProvider.getCredentials('segmentIO'));
    }])
    .config(['EventHubProvider', EventAdapterProvider => {
        EventAdapterProvider
            .register({
                serviceName: 'console',
                handler: 'log'
            })
            .register({
                serviceName: 'googleAnalytics',
                handler: 'trackPageView',
                category: 'tracking',
                eventName: 'pageView'
            })
            .register({
                serviceName: 'googleAnalytics',
                handler: 'trackServerCall',
                category: 'tracking',
                eventName: 'serverCall'
            })
            .register({
                serviceName: 'googleAnalytics',
                handler: 'trackServerCallError',
                category: 'tracking',
                eventName: 'serverCallError'
            })
            /* Stores every journey event in the browser local storage. For debugging purposes only*/
            .register({
                serviceName: 'localstorage',
                handler: 'onEvent'
            })
            .register({
                serviceName: 'segmentIO',
                handler: 'trackJourney',
                category: 'tracking',
                eventName: 'journey'
            })
            .register({
                serviceName: 'segmentIO',
                handler: 'trackPageView',
                category: 'tracking',
                eventName: 'pageView'
            })
            .register({
                serviceName: 'segmentIO',
                handler: 'trackServerCall',
                category: 'tracking',
                eventName: 'serverCall'
            })
            .register({
                serviceName: 'segmentIO',
                handler: 'trackServerCallError',
                category: 'tracking',
                eventName: 'serverCallError'
            });
    }])

    /**
     * Defines the prefix url where the set of states for a sub module should
     * plug into the portal application
     */
    .constant('state_plugin_config', getAndExtendConfigValue('appSettings.statePathConfig', {home: homeState}))
    .constant('defaultLocaleDetails', getConfigValue('userSettings.defaultLocaleDetails'))

    .constant('fnolConfig', getConfigValue('appSettings.fnolConfig'))

    .constant('httpSettings', getConfigValue('httpSettings'))

    .constant('checkForEnrollment', appFeatures['self-enrollment'])
    // 50MB. Used to specify the maximum file size for document upload.
    .constant('maxFileUploadSize', getConfigValue('appSettings.maxFileUploadSize', 50000000))

    .config(['$stateProvider', '$urlRouterProvider', ($stateProvider, $urlRouterProvider) => {
        $stateProvider.state({
            name: 'root',
            url: '',
            template: rootTemplate,
            abstract: true
        });
        $stateProvider.state({
            name: 'enrolled',
            url: '',
            parent: 'root',
            template: '<div ui-view></div>',
            abstract: true,
            resolve: {
                proceedToHomePage: ['gwAuthTokenService', 'oAuth', '$q', (AuthTokenService, oAuth, $q) => {
                    const authenticationService = AuthenticationService(oAuth);
                    const authoritiesPromise = AuthTokenService.grantedAuthorities;
                    return $q.all([authenticationService.waitForLoginRequestComplete, authoritiesPromise]).then(([, authorities]) => {
                        if (authorities.length === 0) {
                            return $q.reject({
                                goToEnrollmentPage: 'signupEnrollment'
                            });
                        }
                        return authorities;
                    }).catch(error => {
                        if (error.error === 'notLoggedIn') {
                            console.warn(error);
                        } else {
                            return $q.reject(error);
                        }
                    });
                }]
            }
        });

        $urlRouterProvider.when('', homeUrl);
        $urlRouterProvider.otherwise($injector => {
            const $state = $injector.get('$state');
            $state.go(homeState);
        });
    }])

    .constant('ASYNC_TRANSLATIONS', true) // Constant that allows us to load translations synchronously (tests/Components Examples)
    .constant('ANGULARI18N_PRESET', '') // Constant that allows us to load Angular Locale from different path (Components Examples)
    .constant('TRANSLATE_PROVIDER_PREFIX', '') // Constant that allows us to load translations from different path (Components Examples)
    .constant('oAuth', (() => {
        const authServer = appFeatures.auth.authServer;
        const authConfig = getConfigValue('auth')[authServer];

        const clientId = AuthConfigUtil.getPortalClientId('ClaimApplication', IS_DISTRIBUTION_BUILD);
        _.defaults(authConfig, {
            clientId,
            portalName: GetXcenterEntryPoint(IS_DISTRIBUTION_BUILD),
            refreshRedirectPage: appFeatures.oAuthRedirectHomePage
        });

        return authConfig;
    })())
    .constant('sessionConfig', getConfigValue('userSettings.sessionConfig', {
        inactivityIntervalMins: 30,
        logoutConfirmationIntervalMins: 1
    }));
